export default class UserAccountExpiredException extends Error {
  constructor(message: string) {
    super(message);
  }
}